import { HttpErrorResponse } from '@angular/common/http';

export function extractErrorMessage(err: unknown): string {
  if (err instanceof HttpErrorResponse) {
    const body = err.error;
    if (body?.errors?.length) return body.errors.join(' ');
    if (body?.message) return body.message;
    if (typeof body === 'string' && body.length < 200) return body;
    return err.statusText || 'An unexpected error occurred.';
  }
  if (err instanceof Error) return err.message;
  return 'An unexpected error occurred.';
}
